<template>
  <div>
    <h3>Editing {{ role }}</h3>
    <p v-if="description">{{ description }}</p>
    <div v-if="role == 'Billing Contact'">
      Billing Contacts require some additional data
    </div>
    <v-autocomplete v-model="contactName" :prepend-icon="showIcon" :items="globalContacts"
      :search-input.sync="contactName" item-text="fullname" item-value="fullname" dense label="Contact"
      @input="onInput">
      <template v-slot:selection="data">
        {{ typeof data.item !== 'object' ? data.item : data.item.fullname }}
      </template>

      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title>
            {{ typeof data.item !== 'object' ? data.item : data.item.fullname }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="typeof data.item === 'object'">
            {{ data.item.email }}
          </v-list-item-subtitle>
          <v-list-item-subtitle v-if="typeof data.item === 'object'">
            {{ data.item.phone }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  props: {
    contact: { type: String, required: false },
    icon: { type: Boolean, required: false },
    globalContacts: { type: Array, required: true },
    role: { type: String, required: false },
    description: { type: String, required: false },
  },
  name: 'VContactsAutocomplete',
  data() {
    return {
      contactName: '',
    };
  },
  created() {
  },
  computed: {
    // ...mapGetters(['getGlobalContactsList']),
    showIcon() {
      return (this.icon) ? 'mdi-account-plus-outline' : '';
    },
  },
  methods: {
    ...mapActions(['fetchGlobalContactsList']),
    onInput(val) {
      if (val && val !== 'New Contact') {
        const contactInfo = (this.globalContacts.filter((a) => a.fullname === val)).shift();
        this.$emit('contactInfo', contactInfo);
      } else {
        this.$emit('update:contact', val);
      }
      this.contactName = '';
    },
  },
  watch: {
    contact(val) {
      this.contactName = val;
    },
  },
};
</script>
